import { UserBasic } from '../_generated/openapi';

export enum BasketballSwitchRequestSwitchType {
  COACH = 1,
  REFEREE = 2,
  JUDGE = 3,
  BASKETBALL_TEAM_TASK = 4,
  TASK = 5,
}

export enum BasketballSwitchRequestEventType {
  GAME = 'App\\Models\\Basketball\\BasketballGame',
  PRACTICE = 'App\\Models\\Basketball\\BasketballPractice',
}

export interface BasketballSwitchRequest {
  id: number;
  switch_type: BasketballSwitchRequestSwitchType;
  switch_id: number | null;
  event_type: BasketballSwitchRequestEventType;
  event_id: number;
  event_date: string;
  user_id: number;
  team_id: number | null;
  new_user_id: number | null;
  note?: string;
  created_at: string;
  updated_at: string | null;
  title: string;
  task: string;
  location: string;
  // Additional attributes
  user: UserBasic;
  new_user: UserBasic | null;
}

export interface BasketballSwitchRequestPossibleJudgeGame {
  date: string;
  label: string;
  value: number;
  team: string;
  team_id: number;
}

export interface BasketballSwitchRequestPossibleCoachGames {
  id: number;
  date: string;
  matchup: string;
  team: {
    id: number;
    name: string;
  };
}

export interface BasketballSwitchRequestPossibleCoachPractices {
  id: number;
  date: string;
  team: {
    id: number;
    name: string;
  };
}

export interface BasketballSwitchRequestPossibleRefereeGames {
  id: number;
  date: string;
  matchup: string;
}
